import React from "react";
import { Typography } from "@mui/material";

function ColorInfo({ answered, marked, notAnswered, visitedQuestions,notVisited }) {

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px 10px",
        borderTop: "1px solid black",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <div
            style={{
              height: "10px",
              width: "10px",
              background: "blue",
            }}
          ></div>
          <Typography style={{ fontSize: "14px" }}>Attempted {`(${answered})`}</Typography>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <div
            style={{
              height: "10px",
              width: "10px",
              background: "purple",
            }}
          ></div>
          <Typography style={{ fontSize: "14px" }}>Review {`(${marked})`}</Typography>
        </div>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <div
            style={{
              height: "10px",
              width: "10px",
              border: "1px solid black",
            }}
          ></div>
          <Typography style={{ fontSize: "14px" }}>Unattempted {`(${notVisited})`}</Typography>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <div
            style={{
              height: "10px",
              width: "10px",
              background: "#d1d1d1ff",
            }}
          ></div>
          <Typography style={{ fontSize: "14px" }}>Skip {`(${Number(notAnswered)})`}</Typography>
        </div>
      </div>
    </div>
  );
}

export default ColorInfo;
